export default {
    loadingLabel() {
        let loading = game.add.sprite(game.world.centerX, game.world.centerY + 100, "loading");
        loading.anchor.setTo(0.5, 0.5);

        let bar = game.add.sprite(game.world.centerX, game.world.centerY - 45, "loading_giraffe");
        bar.anchor.setTo(0.5, 1);
        
        let barBg = game.add.sprite(game.world.centerX, game.world.centerY, "loading_island");
        barBg.anchor.setTo(0.5, 0.5);
        
        game.load.setPreloadSprite(bar, 1);
    },

    preload() {
        this.loadingLabel();

        // Music
        game.load.audio('space-1', 'assets/music/space-1.mp3');
        game.load.audio('dialog-1', 'assets/music/dialog-1.mp3');
        game.load.audio('dialog-2', 'assets/music/dialog-2.mp3');

        // Sounds
        game.load.audio('alien-1', 'assets/sounds/alien-1.wav');
        game.load.audio('alien-2', 'assets/sounds/alien-2.wav');
        game.load.audio('alien-3', 'assets/sounds/alien-3.wav');
        game.load.audio('alien-4', 'assets/sounds/alien-4.wav');
        game.load.audio('boom-1', 'assets/sounds/boom-1.wav');
        game.load.audio('pop-1', 'assets/sounds/pop-1.wav');
        game.load.audio('put-2', 'assets/sounds/put-2.wav');
        game.load.audio('pick-3', 'assets/sounds/pick-3.wav');
        game.load.audio('drop-1', 'assets/sounds/drop-1.wav');
        game.load.audio('drop-2', 'assets/sounds/drop-2.wav');
        game.load.audio('flame-2', 'assets/sounds/flame-2.wav');
        game.load.audio('flame-4', 'assets/sounds/flame-4.wav');

        // Images
        game.load.image('pre', 'assets/levels/pre.png');
        game.load.image('background', 'assets/background.png');
        game.load.image('title', 'assets/title.png');
        game.load.image('win', 'assets/win.png');
        game.load.image('win_pl', 'assets/win_pl.png');
        game.load.image('lost', 'assets/lost.png');

        // Atlases
        game.load.atlas('hero', 'assets/hero.png', 'assets/hero.json');
        game.load.atlas('hero_pantless', 'assets/hero_pantless.png', 'assets/hero_pantless.json');
        game.load.atlas('items', 'assets/items.png', 'assets/items.json');
        game.load.atlas('ship', 'assets/ship.png', 'assets/ship.json');
        game.load.atlas('effects', 'assets/effects.png', 'assets/effects.json');
        game.load.atlas('actors', 'assets/actors.png', 'assets/actors.json');

        // Fonts
        game.load.bitmapFont('nokia', 'assets/fonts/nokia.png', 'assets/fonts/nokia.xml');

        game.load.tilemap('ship1', 'assets/levels/pre1.json', undefined, Phaser.Tilemap.TILED_JSON);


    },

    create() {
        game.state.start("menu");
    }
};


// WEBPACK FOOTER //
// ./src/states/load.js